import { render, staticRenderFns } from "./LenonProfilePhoto.vue?vue&type=template&id=3b3f6c39&scoped=true&"
import script from "./LenonProfilePhoto.vue?vue&type=script&lang=js&"
export * from "./LenonProfilePhoto.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b3f6c39",
  null
  
)

export default component.exports